import { useForm } from 'react-hook-form';
import Utils from '../../../Utils';
import Modal from '../../../Components/Modal/Modal';

import styles from './CalendarPage.module.css';

import API from '../../../Utils/api';

export default function CreateWorkout({ user, data, closeCB, onSuccess, onFailure }) {
    const { register, handleSubmit } = useForm({
        defaultValues: {
            workoutStart: Utils.dateToDatetimeFormat(new Date(data.start))
        }
    });

    const { min, max } = Utils.dateToDatetimeFormatRangeDay(data.start);

    const onEventCreate = async ({ workoutStart }) => {
        try {
            const start = new Date(workoutStart);
            const { data } = await API.addUserWorkout(user._id, {
                workoutStart: start.toISOString(),
                workoutEnd: new Date(start.getTime() + 60 * 60 * 1000).toISOString()
            });
            onSuccess('Workout created!', data);
        } catch (err) {
            onFailure("Couldn't create workout!");
        }
    };

    return (
        <Modal
            closeCB={closeCB}
            title={'Create Workout'}
            footer={
                <button className='btn btn-primary' onClick={handleSubmit(onEventCreate)}>
                    Add
                </button>
            }
        >
            <form className={styles.form}>
                <div className='form-group'>
                    <label htmlFor='workoutStart'>Starting time</label>
                    <input
                        type='datetime-local'
                        {...register('workoutStart', { required: true })}
                        className='form-control'
                        placeholder='Start Datetime'
                        min={min}
                        max={max}
                        lang='en'
                    />
                </div>
            </form>
        </Modal>
    );
}
